export class Service
{
	changeMode (parent)
	{
		if ($(parent).val() == 3)
		{
			$('#service_row_1').slideDown();
			$('#service_row_2').slideDown();
			$('#service_row_1 input[disabled]').prop('disabled', false);
			$('#service_row_2 input[disabled]').prop('disabled', false);
			$('#service_row_1').append($('#service_people_item'));

		}
		else if ($(parent).val() == 2)
		{
			$('#service_row_1').slideUp();
			$('#service_row_2').slideDown();
			$('#service_row_1 input').prop('disabled', true);
			$('#service_row_2 input[disabled]').prop('disabled', false);
			$('#service_row_2').append($('#service_people_item'));
		}
		else
		{
			$('#service_row_1').slideDown();
			$('#service_row_2').slideUp();
			$('#service_row_1 input[disabled]').prop('disabled', false);
			$('#service_row_2 input').prop('disabled', true);
			$('#service_row_1').append($('#service_people_item'));
		}

		//$('.cip-form__answer').html('');
		this.cipChanged();
	}

	calcCIP (parent)
	{
		let _this = this;
		let form = $(parent);

		form.find('.form__loader').addClass('active');

		setTimeout(function(){
			$.ajax({
				url: "/ajax.php?mid=37&action=calcCIP",
				type: 'POST',
				data: form.serialize(),
				dataType: "html",
				success: function(html){
					$('.cip-form__answer').replaceWith(html);
					$('.cip-form__answer').fadeIn();
					form.find('.form__loader').removeClass('active');
				},
				error: function(err){
					if (err.statusText === "abort") {
				// Запрос был прерван, можно просто проигнорировать
				console.warn('Запрос был прерван.');
			} else {
				// Обработка остальных ошибок
				alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
			}
				}
			});
		}, 450);

		
	}

	cipChanged()
	{
		if ($('.cip-form__answer').text() != '')
		{
			$('.cip-form__answer').fadeOut();
		}
	}
}